







































import 'mapbox-gl/dist/mapbox-gl.css';
import { Component, Prop } from 'vue-property-decorator';
import mapboxgl from 'mapbox-gl';
import { SwExtendedVue } from '../sw-extended-vue';
import SwMapZoom from './controls/sw-map-zoom.vue';
// import SwMapLayer from './controls/sw-map-layer.vue';
import { MapLocation, MarkerConfig } from './types';
import { googleStyle } from './util.service';

@Component({
  components: {
    SwMapZoom,
    // SwMapLayer,
  },
})
export default class SwMapGl extends SwExtendedVue {
  @Prop({ type: Array, default () { return [0, 0]; } })
  initCenter: [number, number];

  @Prop({ type: Number, default: 1 })
  initZoom: number;

  @Prop({ type: Array, default () { return []; } })
  locations: MapLocation[];

  @Prop({ type: Object, default() { return { name: 'location', size: 22, color: '#fb6' }; } })
  markerConfig: MarkerConfig;

  @Prop({ type: Boolean, default: false })
  enableExport: boolean;

  cssPrefix: string = 'sw-map-gl';

  mapObj: mapboxgl.Map;
  zoom: number = this.initZoom;
  private zoomChangeFromControl: boolean = false;

  popUps: mapboxgl.Popup[] = [];
  markers: mapboxgl.Marker[] = [];
  baseLayer: mapboxgl.Layer;
  isLayerControlVisible = false;

  get mapZoomConfig() {
    return {
      maxRequestZoom: 14, // level higher than this would not trigger tile request.
      maxZoom: 18,
    };
  }

  mounted() {
    this.initMap();
    this.initZoomControl();
  }

  initMap() {
    mapboxgl.accessToken = 'false';
    const mapOptions: mapboxgl.MapboxOptions = {
      container: this.$refs.mapDiv! as HTMLElement,
      style: googleStyle,
      center: this.initCenter,
      zoom: this.initZoom,
    };
    this.mapObj = new mapboxgl.Map(mapOptions);
    // console.warn('mapgl initial complete.');
    this.mapObj.on('load', () => {
      this.mapObj.on('moveend', this.onCenterChanged);
      this.mapObj.on('zoomend', this.onZoomChanged);
    });
  }

  resetMap(): void {
    if (this.mapObj) {
      this.mapObj.setCenter(this.initCenter);
      this.mapObj.setZoom(this.initZoom);
    }
    this.$emit('reset-map');
  }

  resetRotate() {
    if (this.mapObj) {
      this.mapObj.setBearing(0);
    }
  }

  onCenterChanged(): void {
    const center = this.mapObj.getCenter();
    this.$emit('center-change', [Number(center.lng), Number(center.lat)]);
  }

  onZoomChanged(): void {
    if (this.mapObj) {
      const currZoom = this.mapObj.getZoom();
      // TODO
      this.$emit('zoom-change', currZoom);
    }
  }

  initZoomControl(): void {
    this.mapObj!.on('zoomend', this.updateMapScale);
  }

  updateMapScale(): void {
    this.zoom = this.mapObj!.getZoom();
  }

  handleZoomChange(value: any): void {
    if (this.mapObj) {
      this.mapObj.setZoom(Number(value));
      this.zoom = Number(value);
    }
  }
}
